<div
  class="box-border flex items-center justify-between gap-6 px-6 py-4 bg-neutrals-0 border-neutrals-300 round-top-alt"
>
  <div class="flex flex-grow gap-6">
    <div
      class="grid items-center justify-start grid-flow-col gap-2"
      *ngIf="lastSessionTime"
    >
      <ui-icon name="hour-glass" fill="neutrals-900" m-size="18" size="18" />
      <ui-paragraph
        type="p12"
        mobile-type="p12"
        text-color="neutrals-600"
        class="w-[60px]"
      >
        {{ elapsedTime }}
      </ui-paragraph>
    </div>
    <div class="border-r-2 border-[#D2DEF1]"></div>
    <div
      class="grid items-center justify-start grid-flow-col gap-2"
      *ngIf="lastSessionTime"
    >
      <div class="relative group">
        <ui-icon name="user-check" fill="neutrals-900" m-size="18" size="18" />
        <div
          class="flex justify-center absolute left-1/2 -translate-x-1/2 mt-2 w-[170px] group-hover:opacity-100 bg-[#0B2C56] text-[#EFEFEF] text-sm p-2 rounded shadow-lg opacity-0 transition-opacity duration-300 z-10"
        >
          <ui-paragraph
            type="p10"
            mobile-type="p10"
            text-color="neutrals-0"
            font-weight="regular"
          >
            Último mensaje del cliente
          </ui-paragraph>
          <div
            class="absolute top-[2px] left-1/2 -translate-x-1/2 -mt-2 w-3 h-3 bg-[#0B2C56] rotate-45"
          ></div>
        </div>
      </div>
      <ui-paragraph type="p12" mobile-type="p12" text-color="neutrals-600">
        {{ formatDateWithIntl(lastSessionTime) }}
      </ui-paragraph>
    </div>
    <div class="flex justify-center items-center">
      <track-lead-card-bottom-chip
        *ngIf="dataLead?.channelName"
        [value]="dataLead?.channelName"
        [value]="getChannelNameLabel()"
        [width]="'100px'"
        [truncate]="true"
        borderColor="border-neutrals-700"
      ></track-lead-card-bottom-chip>
    </div>
  </div>

  <div class="flex gap-6">
    <div class="h-[30px] w-[40px]" #menuContainer>
      <button
        class="bg-[#FDDE2F] w-[40px] rounded-[500px] px-3 py-1 flex items-center justify-center h-[30px] disabled:bg-[#A9BCD9] disabled:text-white disabled:cursor-not-allowed"
        (click)="onShowDisabledTypes()"
        type="button"
        [disabled]="!isActivated"
      >
        <ui-icon
          name="archive"
          fill="neutrals-900"
          m-size="20"
          size="20"
          *ngIf="!isLoadingArchive && isActivated"
        />
        <ui-icon
          name="archive"
          fill="neutrals-0"
          m-size="20"
          size="20"
          *ngIf="!isLoadingArchive && !isActivated"
        />
        <ui-loader type="primary" size="2xl" *ngIf="isLoadingArchive" />
      </button>
      <div
        *ngIf="showMenu"
        class="w-[217px] px-4 py-3 relative max-h-[380px] z-10 bg-white top-[12px] rounded-[8px] shadow-[2px_2px_12px_-0_rgba(0,0,0,0.25)]"
      >
        <ui-paragraph
          class="px-2"
          type="p16"
          mobile-type="p16"
          text-color="neutrals-900"
          font-weight="semibold"
        >
          Categoria de archivado
        </ui-paragraph>
        <mat-radio-group
          [(ngModel)]="selectedOption"
          color="primary"
          class="flex flex-col max-h-[230px] overflow-y-auto pr-2"
        >
          <mat-radio-button
            *ngFor="let option of disabledTypes"
            [value]="option"
          >
            <ui-paragraph
              type="p12"
              mobile-type="p12"
              text-color="neutrals-700"
              font-weight="regular"
            >
              {{ option.description }}
            </ui-paragraph>
          </mat-radio-button>
        </mat-radio-group>
        <div class="flex justify-center mt-4">
          <button
            class="bg-[#FDDE2F] rounded-[500px] px-4 py-3 flex justify-center gap-2 w-[140px]"
            (click)="onLeadArchive()"
          >
            <ui-paragraph
              type="p12"
              mobile-type="p12"
              text-color="neutrals-900"
              font-weight="semibold"
            >
              Archivar
            </ui-paragraph>
          </button>
        </div>
      </div>
    </div>

    <button
      class="bg-[#FDDE2F] w-[110px] rounded-[500px] px-4 py-1 flex items-center justify-center h-[30px] disabled:bg-[#A9BCD9] disabled:text-white disabled:cursor-not-allowed"
      (click)="onBotMute()"
      [disabled]="isLoading || !isActivated"
      type="button"
    >
      <div *ngIf="!isLoading">
        <ui-paragraph
          type="p12"
          mobile-type="p12"
          textColor="primary-900"
          font-weight="semibold"
          *ngIf="!isBotMuted"
        >
          Apagar Bot
        </ui-paragraph>
        <ui-paragraph
          type="p12"
          mobile-type="p12"
          textColor="primary-900"
          font-weight="semibold"
          *ngIf="isBotMuted"
        >
          Prender Bot
        </ui-paragraph>
      </div>
      <ui-loader type="secondary" size="md" *ngIf="isLoading" />
    </button>
  </div>

  <div class="grid items-center grid-flow-col gap-6" #menuAgentsRef>
    <button>
      <ui-icon name="search" fill="neutrals-600" m-size="24" size="24" />
    </button>
    <button (click)="toggleMenuLead()" class="relative">
      <ui-icon name="vertical-menu" fill="neutrals-600" m-size="24" size="24" />
    </button>
    <div
      *ngIf="showMenuAgents"
      class="absolute z-[999] top-[40px] right-[35px] rounded-[8px] bg-white"
    >
      <div class="grid grid-flow-row w-[280px] box-border">
        <button
          mat-menu-item
          class="flex flex-row justify-start items-center gap-2"
          (click)="assignAnotherExecutive($event)"
          [disabled]="!isActivated"
        >
          <ui-icon
            class="inline-flex flex-none mr-2"
            name="swap"
            fill="neutrals-600"
            size="16"
            mSize="16"
          />
          <ui-paragraph
            class="inline-flex flex-grow"
            class="capitalize"
            type="p12"
            mobile-type="p12"
            text-color="neutrals-900"
            font-weight="regular"
          >
            Asignar cliente a otra ejecutiva
          </ui-paragraph>
        </button>

        <button
          mat-menu-item
          class="flex flex-row justify-start items-center gap-2"
          [disabled]="!isActivated"
        >
          <ui-icon
            class="inline-flex flex-none mr-2"
            name="clock"
            fill="neutrals-600"
            size="16"
            mSize="16"
          />
          <ui-paragraph
            class="inline-flex flex-grow"
            type="p12"
            mobile-type="p12"
            text-color="neutrals-900"
            font-weight="regular"
          >
            Agregar alarma
          </ui-paragraph>
        </button>

        <button
          mat-menu-item
          class="flex flex-row justify-start items-center gap-2"
          [disabled]="!isActivated"
        >
          <ui-icon
            class="inline-flex flex-none mr-2"
            name="file"
            fill="neutrals-600"
            size="16"
            mSize="16"
          />
          <ui-paragraph
            class="inline-flex flex-grow"
            type="p12"
            mobile-type="p12"
            text-color="neutrals-900"
            font-weight="regular"
          >
            Ver historial de cotizaciones
          </ui-paragraph>
        </button>
      </div>
    </div>
  </div>
  <div
    #submenuRef
    *ngIf="showSubmenu"
    class="max-h-[200px] w-[217px] px-4 py-3 absolute h-[380px] z-[1000] bg-white top-[80px] right-[10px] rounded-[8px] shadow-[2px_2px_12px_-0_rgba(0,0,0,0.25)]"
  >
    <mat-radio-group
      [(ngModel)]="selectedOptionAgent"
      color="primary"
      class="flex flex-col max-h-[230px]"
      *ngIf="!visibleOptions"
    >
      <mat-radio-button *ngFor="let option of agentsList" [value]="option">
        <ui-paragraph
          type="p12"
          mobile-type="p12"
          text-color="neutrals-700"
          font-weight="regular"
        >
          {{ option.firstName + ' ' + option.lastName }}
        </ui-paragraph>
      </mat-radio-button>
    </mat-radio-group>

    <div
      *ngIf="visibleOptions"
      class="flex items-center justify-center h-[60%]"
    >
      <ui-loader type="primary" size="2xl" />
    </div>

    <div class="flex justify-center mt-3">
      <button
        class="bg-[#FDDE2F] rounded-[6px] px-6 py-3 flex justify-center gap-2 w-[140px]"
        (click)="onAssignAnotherAgent()"
      >
        <ui-icon
          *ngIf="!isLoadingAssignment"
          name="send"
          m-size="20"
          size="20"
          fill="neutrals-900"
        />
        <ui-paragraph
          type="p12"
          mobile-type="p12"
          text-color="neutrals-900"
          font-weight="semibold"
          *ngIf="!isLoadingAssignment"
        >
          Asignar
        </ui-paragraph>
        <ui-loader type="secondary" size="md" *ngIf="isLoadingAssignment" />
      </button>
    </div>
  </div>
</div>
